module.exports = __webpack_public_path__ + "static/media/dont1.1f1d46b5.png";